/**
 *  项目的配置文件
 */
//因为如果从common.js引入，而request又引入common, common也引入request。会出问题，所以直接在此定义getQueryVariable
const getQueryVariable = (variable) => {
     let query = window.location.search.substring(1);
     let vars = query.split("&");
     for (let i = 0; i < vars.length; i++) {
          let pair = vars[i].split("=");
          if (pair[0] == variable) {
               return pair[1];
          }
     }
     return false;
}

//确保第一时间获取到 identity值，要不然打开则undefined
const getIdentity = () => {
     if (localStorage.identity && localStorage.identity != 'false') {
          return localStorage.identity
     } else {
          if (getQueryVariable('storeId')) return 'seller'
          if (getQueryVariable('adminId')) return 'admin'
     }
}

export const apiUrl = `https://${getIdentity()}.cechds.com/`//接口请求地址
export const chatUrl = 'wss://im.cechds.com'//客服地址
export const storeUrl = `https://${getIdentity()}.cechds.com/`;//对应的商户后台地址
export const pcUrl = 'https://mall.cechds.com/'  //如果没有pc端的话，这里填空，不是去掉
export const identity = getIdentity()

export const curLang = 'zh';//当前语言,zh:中文，若为其他语言，需要对应/src/assets/language下面的文件名

/** copyright *** slodon *** version-v3.8 *** date-2022-10-13 ***主版本v4.2**/


